import {
  CheckSquareOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, Space, Typography } from "antd";

const { Text } = Typography;

interface BulkActionBarProps {
  count: number;
  loading?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onClear: () => void;
}

export const BulkActionBar = ({
  count,
  loading,
  onEdit,
  onDelete,
  onClear,
}: BulkActionBarProps) => {
  if (!count) return null;
  return (
    <div className="deadline-action-bar">
      <Space>
        <CheckSquareOutlined className="deadline-action-bar-icon" />
        <Text strong className="deadline-action-bar-text">
          <span className="deadline-action-bar-count">{count}</span> 件選択中
        </Text>
        <button
          type="button"
          className="deadline-action-bar-clear"
          onClick={onClear}
        >
          選択解除
        </button>
      </Space>
      <Space>
        <Button type="primary" icon={<EditOutlined />} onClick={onEdit}>
          ルールを変更
        </Button>
        <Button
          danger
          icon={<DeleteOutlined />}
          loading={loading}
          onClick={onDelete}
        >
          削除
        </Button>
      </Space>
    </div>
  );
};
